module.exports = __webpack_public_path__ + "static/media/recreation-brikk-preview.3a4f1b55.png";